module.exports = __webpack_public_path__ + "static/media/comment.543c0129.jpg";